import {useEffect, useState} from "react";
import _ from "lodash"
import imageCompression from "browser-image-compression";

const initialData = {
    profileLink: "",
    name: "",
    job: "",
    residence: "",
    description: "",
    profileImageUrl: "",
    profileImage: null,
    backgroundImageUrl: "",
    backgroundImage: null,
    linkValid: false,
    cardValid: false,
}
export const useProfileInfoUpdater = (profile) => {
    const [data, setData] = useState(initialData)
    const [oldData, setOldData] = useState(null)
    const [isChanged, setChanged] = useState(false)

    useEffect(() => {
        if (profile == null) return

        const profileInfo = {
            profileLink: profile.profileLink,
            name: profile.name,
            description: profile.description,
            job: profile.job,
            role: profile.role,
            residence: profile.residence,
            profileImage: null,
            profileImageUrl: profile.profileImageUrl && `/api/profile/image?key=${profile.profileImageUrl}`,
            backgroundImage: null,
            backgroundImageUrl: profile.backgroundImageUrl && `/api/profile/image?key=${profile.backgroundImageUrl}`,
            linkValid: true,
            cardValid: true,
        };

        setOldData(profileInfo)
        setData(_.cloneDeep(profileInfo))
    }, [profile])

    useEffect(() => {
        if (oldData == null) {
            return
        }
        const checkChanged = () => {
            for (const key of Object.keys(initialData)) {
                const oldValue = oldData[key]
                const newValue = data[key]
                if (oldValue !== newValue) return true
            }
            return false
        }

        setChanged(checkChanged())
    }, [data])

    const updater = {
        profileLink: data.profileLink,
        setProfileLink(newValue) {
            setData({...data, profileLink: newValue})
        },
        name: data.name,
        setName(newValue) {
            setData({...data, name: newValue})
        },
        description: data.description,
        setDescription(newValue) {
            setData({...data, description: newValue})
        },
        job: data.job,
        setJob(newValue) {
            setData({...data, job: newValue})
        },
        residence: data.residence,
        setResidence(newValue) {
            setData({...data, residence: newValue})
        },
        profileImage: data.profileImage,
        profileImageUrl: data.profileImageUrl,
        setProfileImage(imagePath, imageData) {
            const options = {
                maxSizeMB: 10,
                maxWidthOrHeight: 200,
                fileType: 'image/jpeg'
            }

            const newData = {...data}
            imageCompression(imageData, options)
                .then((compressedImage) => {
                    newData.profileImage = compressedImage
                    newData.profileImageUrl = imagePath
                    setData(newData)
                })
        },
        backgroundImage: data.backgroundImage,
        backgroundImageUrl: data.backgroundImageUrl,
        setBackgroundImage(newValue) {
            const imagePath = URL.createObjectURL(newValue);

            const options = {
                maxSizeMB: 10,
                maxWidthOrHeight: 1200,
                fileType: 'image/jpeg'
            }

            const newData = {...data}
            imageCompression(newValue, options)
                .then((compressedImage) => {
                    newData.backgroundImage = compressedImage
                    newData.backgroundImageUrl = imagePath
                    setData(newData)
                })
        },
        linkValid: data.linkValid,
        toggleLinkValid() {
            setData({...data, linkValid: !data.linkValid})
        },
        cardValid: data.cardValid,
        toggleCardValid() {
            setData({...data, cardValid: !data.cardValid})
        }
    }

    return [updater, isChanged]
}